<template>
  <div id="reportclaim" data-page-type="flow" data-test-component="reportClaim">
    <!-- /************* HEADER WITH X BUTTON *************/ -->
    <div class="container">
      <header class="header-static">
        <a class="close-button open-modal" @click="close">
          <span class="icon icon-close" />
        </a>
      </header>
    </div>
    <Form ref="form" v-slot="{ meta, errors }" as="div">
      <div id="mainView" class="flow__body row container">
        <div class="small-12 medium-12 large-12 columns">
          <!-- /************* MAIN STEP VIEW *************/ -->
          <!-- <keep-alive> -->
          <transition name="fade" mode="out-in">
            <component
              :is="currentComponent"
              :vue-model="vueModel"
              :name="'main-view'"
              :index="index"
              :tracking-vm="getTrackingVM(false)"
              @show-back-button="toggleBackButton"
              @stop-timer="timeoutNotificationActive = false"
              @component-mounted="componentMounted()"
              :errors="errors"
            />
          </transition>
          <!-- </keep-alive> -->
        </div>
        <div class="small-12 medium-12 large-6 columns">
          <!-- /************* BACK & NEXT BUTTON *************/ -->
          <div v-if="index < 4" v-cloak id="next" class="row">
            <div class="small-6 medium-6 columns">
              <button
                v-if="showBackButton"
                class="button secondary"
                data-test="create-claim-flow-back-button"
                :disabled="buttonDisabled"
                @click.stop="back"
              >
                {{ vueModel.ContentViewModel.GeneralContent.ButtonTextBack }}
              </button>
            </div>
            <div class="small-6 medium-6 columns">
              <button
                class="button"
                data-test="create-claim-flow-next-button"
                :disabled="buttonDisabled"
                @click.stop="next"
              >
                {{ vueModel.ContentViewModel.GeneralContent.ButtonTextNext }}
                <div v-show="saving" class="spinner spinner-button" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Form>

    <!-- /************* PROGRESS BAR *************/ -->
    <progress-bar
      :flow-index="index"
      :pills="progressBar"
      :name="vueModel.CreateClaimEntity.ProductName"
    />

    <!-- /************* POPUP IF MEMBER CLICK X *************/ -->
    <transition name="modal">
      <v-modal v-cloak :is-open="showCloseModal" @close="closeModal">
        <template #title>
          <h3 v-html="vueModel.ContentViewModel.GeneralContent.ModalTitleExitFlow" />
        </template>
        <template #content>
          <div>
            <div v-html="vueModel.ContentViewModel.GeneralContent.ModalContentExitFlow" />
          </div>
        </template>
        <template #buttons>
          <div class="row">
            <div class="medium-6 small-12 columns">
              <a
                class="button secondary large"
                @click="closeModal"
                v-html="vueModel.ContentViewModel.GeneralContent.ModalButtonTextCancel"
              />
            </div>
            <div class="medium-6 small-12 columns">
              <a
                class="button large"
                @click="leave"
                v-html="vueModel.ContentViewModel.GeneralContent.ModalButtonTextOK"
              />
            </div>
          </div>
        </template>
      </v-modal>
    </transition>

    <!-- /************* SCALEPOINT WARNING *************/ -->
    <transition name="modal">
      <v-modal v-cloak :is-open="showScalePointModal" @close="closeScalePointModal">
        <template #title>
          <h3>
            {{ scalePointModalTitle }}
          </h3>
        </template>
        <template #content>
          <div id="scalepoint-modal" v-html="scalePointModalContent" />
        </template>
        <template #footer>
          <div>
            <button class="button large" @click="closeScalePointModal">
              Ok
            </button>
          </div>
        </template>
      </v-modal>
    </transition>
  </div>
</template>

<script>
import Affix from '@/components/UI/Affix.vue';
import BaseMixin from '@/components/Feature/BaseMixin.vue';
import ProgressBar from '@/components/UI/ProgressBar.vue';
import ReportClaimAccidentStep2 from '@/components/Feature/Claims/flows/components/ReportClaimAccidentStep2.vue';
import ReportClaimAccidentStep3 from '@/components/Feature/Claims/flows/components/ReportClaimAccidentStep3.vue';
import ReportClaimCarStep2 from '@/components/Feature/Claims/flows/components/ReportClaimCarStep2.vue';
import ReportClaimCarStep3 from '@/components/Feature/Claims/flows/components/ReportClaimCarStep3.vue';
import ReportClaimContentStep2 from '@/components/Feature/Claims/flows/components/ReportClaimContentStep2.vue';
import ReportClaimTravelStep2 from '@/components/Feature/Claims/flows/components/ReportClaimTravelStep2.vue';
import ReportClaimContentStep3 from '@/components/Feature/Claims/flows/components/ReportClaimContentStep3.vue';
import ReportClaimContentTravelStep3 from '@/components/Feature/Claims/flows/components/ReportClaimContentTravelStep3.vue';
import ReportClaimTravelStep3 from '@/components/Feature/Claims/flows/components/ReportClaimTravelStep3.vue';
import ReportClaimHouseStep2 from '@/components/Feature/Claims/flows/components/ReportClaimHouseStep2.vue';
import ReportClaimPetStep2 from '@/components/Feature/Claims/flows/components/ReportClaimPetStep2.vue';
import ReportClaimPetStep3 from '@/components/Feature/Claims/flows/components/ReportClaimPetStep3.vue';
import ReportClaimSalaryStep2 from '@/components/Feature/Claims/flows/components/ReportClaimSalaryStep2.vue';
import ReportClaimServicesMixin from '@/components/Feature/Claims/flows/ReportClaimServicesMixin.vue';
import ReportClaimSharedStep1 from '@/components/Feature/Claims/flows/components/ReportClaimSharedStep1.vue';
import ReportClaimSharedStep2 from '@/components/Feature/Claims/flows/components/ReportClaimSharedStep2.vue';
import ReportClaimSharedStep4 from '@/components/Feature/Claims/flows/components/ReportClaimSharedStep4.vue';
import ReportClaimVacationHouseStep2 from '@/components/Feature/Claims/flows/components/ReportClaimVacationHouseStep2.vue';
import ReportClaimVacationHouseStep3 from '@/components/Feature/Claims/flows/components/ReportClaimVacationHouseStep3.vue';
import Utility from '@/common/UtilityFunctions.js';
import ValidatePropsMixin from '@/components/Feature/ValidatePropsMixin.vue';

import axios from 'axios';
import { Form } from 'vee-validate';

export default {
  name: 'ReportClaimMain',
  components: {
    Form,
    Affix,
    ProgressBar,

    // Shared
    'shared-step-1': ReportClaimSharedStep1,
    'shared-step-2': ReportClaimSharedStep2,
    'shared-step-4': ReportClaimSharedStep4,

    // Car
    'product-id-100-step-2': ReportClaimCarStep2,
    'product-id-100-step-3': ReportClaimCarStep3,

    // Content
    'product-id-300-step-2': ReportClaimContentStep2,
    'product-id-300-step-3': ReportClaimContentStep3,
    'product-id-300-step-3-travel': ReportClaimContentTravelStep3,

    // Travel
    'product-id-250-step-2': ReportClaimTravelStep2,
    'product-id-250-step-3': ReportClaimTravelStep3,

    // Accident
    'product-id-200-step-2': ReportClaimAccidentStep2,
    'product-id-200-step-3': ReportClaimAccidentStep3,

    // Accident
    'product-id-280-step-2': ReportClaimSalaryStep2,

    // Pet
    'product-id-320-step-2': ReportClaimPetStep2,
    'product-id-320-step-3': ReportClaimPetStep3,

    // Vacation House
    'product-id-440-step-2': ReportClaimVacationHouseStep2,
    'product-id-440-step-3': ReportClaimVacationHouseStep3,

    // House
    'product-id-410-step-2': ReportClaimHouseStep2
  },
  mixins: [BaseMixin, ReportClaimServicesMixin, ValidatePropsMixin],
  props: {
    model: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      vueModel: this.model,
      index: 1,
      name: 'reportClaim',
      showCloseModal: false,
      damageCode: Utility.getQueryVariable('dc'),
      referenceToQuestionnaireId: Utility.getQueryVariable('ref'),
      showBackButton: false,
      saving: false,
      timeoutNotificationActive: true,
      buttonDisabled: false,
      showScalePointModal: false,
      scalePointModalTitle: null,
      scalePointModalContent: null,
      form: null
    };
  },
  computed: {
    currentComponent() {
      let i = 1;

      for (var prop in this.vueModel) {
        if (this.vueModel[prop] !== null && i === this.index) {
          return this.vueModel[prop].VueComponent;
        }

        i++;
      }
      return undefined; // TODO: is this the right default return?
    },
    currentModel() {
      return this.vueModel['CreateClaimStep' + this.index + 'Model'];
    },
    progressBar() {
      var pills = [];

      for (var prop in this.vueModel) {
        if (prop.indexOf('Step') < 0 || this.vueModel[prop] === null) {
          continue;
        }

        pills.push({
          title: this.vueModel[prop].StepTitle
        });
      }

      return pills;
    },
    emptyStep() {
      return this.currentModel === null;
    },
    hasQuestionnaire() {
      return this.index === 1 && this.vueModel.CreateClaimEntity.ProductSpecific !== null;
    },
    isTravel() {
      if (this.vueModel.CreateClaimStep2Model.ProductSpecific === null) {
        return false;
      }

      if (this.vueModel.CreateClaimStep2Model.ProductSpecific.IsTravel === undefined) {
        return false;
      }

      return this.vueModel.CreateClaimStep2Model.ProductSpecific.IsTravel;
    },
    hasScalepoint() {
      if (
        this.vueModel.CreateClaimEntity.PolicyType !== 300 &&
        this.vueModel.CreateClaimEntity.PolicyType !== 440
      ) {
        return false;
      }

      if (this.vueModel.CreateClaimStep3Model === null) {
        return false;
      }

      if (this.vueModel.CreateClaimStep2Model.ProductSpecific.IsTravel) {
        return false;
      }

      return true;
    }
  },
  mounted() {
    // set reference to questionnaire id
    if (this.referenceToQuestionnaireId) {
      this.vueModel.CreateClaimEntity.ClaimQuestionnaireId = this.referenceToQuestionnaireId;
    }

    this.vueModel.files = [];

    // add for house step 2
    this.vueModel.CreateClaimStep2Model.SelectedAddress = null;
  },
  methods: {
    disableButton() {
      if (!this.hasScalepoint) {
        this.buttonDisabled = true;
      }
    },
    dispatchEventCloseForm() {
      this.dispatchEventWithCloseFormAction(true);
    },
    keepAlive() {
      axios
        .get(Utility.constants().API.keep_alive_session)
        .then(() => {})
        .catch((error) => {
          this.dispatchEventWithApiError('keep_alive_session: ' + error?.message);

          Utility.logError(error, this);
        });
    },
    toggleScalePointModal(title, content) {
      this.scalePointModalTitle = title;
      this.scalePointModalContent = content;
      this.showScalePointModal = true;
    },
    close() {
      this.showCloseModal = true;
    },
    closeScalePointModal() {
      this.showScalePointModal = false;
    },
    checkLossItems() {
      const vm = this;
      const data = {
        ScalepointTokenCase:
          this.vueModel.CreateClaimEntity.ProductSpecific.ScalePointEntity.ScalepointTokenCase
      };

      axios
        .post(Utility.constants().API.hasscalepointloss, data)
        .then((response) => {
          const hasScalePointLoss = response.data.Data.ScalepointHasLoss;
          const title = response.data.FrontEndTitleMessage;
          const content = response.data.FrontEndContentMessage;

          if (!hasScalePointLoss) {
            return vm.toggleScalePointModal(title, content);
          }

          if (!response.data.IsSuccess) {
            this.dispatchEventWithApiError(
              'hasscalepointloss: ' + response?.data?.FrontEndTitleMessage
            );
          }

          return vm.goToNext();
        })
        .catch((error) => {
          this.dispatchEventWithApiError('hasscalepointloss: ' + error?.message);

          Utility.logError(err, this);
        });
    },
    async next() {
      const result = await this.$refs.form.validate();

      var vm = this;

      // vm.keepAlive();

      if (!result.valid) {
        return vm.scrollToFirstError();
      }

      this.disableButton();

      if (vm.index === 3 && this.hasScalepoint) {
        return this.checkLossItems();
      }

      return vm.goToNext();
    },
    goToNext() {
      if (this.hasQuestionnaire) {
        return this.populateQuestionnaireAndGoToNext();
      }

      this.index++;

      if (this.emptyStep) {
        return this.next();
      }
    },
    back() {
      this.disableButton();
      this.index--;

      if (this.emptyStep) {
        return this.back();
      }
    },
    closeModal() {
      this.showCloseModal = false;
    },
    leave() {
      this.showCloseModal = false;
      this.dispatchEventCloseForm();
      location.href = this.vueModel.ContentViewModel.GeneralContent.LinkToPageAfterExit;
    },
    toggleBackButton(show) {
      this.showBackButton = show;
    },
    componentMounted() {
      this.buttonDisabled = false;
    }
  }
};
</script>
